(function () {
  document.addEventListener('DOMContentLoaded', function () {
    const toggleButton = document.querySelector('.collection-hero__description-toggle button');
    const moreText = toggleButton.textContent;
    const description = document.querySelector('.collection-hero__description');

    toggleButton.addEventListener('click', function () {
      if (description.classList.contains('collection-hero__description--long')) {
        description.classList.remove('collection-hero__description--long');
        toggleButton.textContent = toggleButton.dataset.lessText;
      } else {
        description.classList.add('collection-hero__description--long');
        toggleButton.textContent = moreText;
      }
    });
  });
})();
